import { selectUserConfigTimeZone } from 'app/userPreferences/selectors';
import DateService from 'services/dateService';
import { useAppSelector } from 'store/hooks';
import type { UseTimeZoneResultType } from 'hooks/types';

const {
  getFormattedDate,
  setDateTz,
  getEndDate,
  getStartDate,
  setFormattedDate,
  getIsoDate,
  getDateRanges,
  convertDateObjectToDateString,
  dateTz,
  getLocalDate,
  date,
  getDateTz,
  getFormattedDateByTimeZone,
} = DateService;

const useTimeZone = (): UseTimeZoneResultType => {
  const timeZone = useAppSelector(selectUserConfigTimeZone);

  if (timeZone) {
    setDateTz(timeZone);
  }

  return {
    getFormattedDate: (...arg) => getFormattedDate(...arg),
    getFormattedDateByTimeZone: (...arg) => getFormattedDateByTimeZone(...arg),
    getEndDate,
    getStartDate,
    setFormattedDate,
    getIsoDate,
    getDateRanges: (...arg) => getDateRanges(...arg),
    convertDateObjectToDateString,
    dateTz,
    getLocalDate,
    setDateTz,
    date,
    getDateTz,
  };
};

export default useTimeZone;
